<template>
    <div class="widget-overlay">
        Loading...
    </div>
</template>

<script>
    export default {
        //
    }
</script>
